import LegalPage from "@/pages/legal/LegalPage";

export default function UsagePolicy() {
  return (
    <LegalPage title="Kullanım Politikası" testId="legal-usage">
      <div className="rounded-2xl border border-zinc-200 bg-[#F0FDFA] p-7">
        <h2 className="font-display text-lg font-bold text-[#062B2B]">Çerez Politikası</h2>
        <p className="mt-3">
          Çerez veya bilinen ismiyle "cookie", mobil ve masaüstü cihazlar kullanarak
          sitemizi (www.cagrinetwork.com.tr) ziyaret ettiğinizde bilgisayarınız veya mobil
          cihazınıza (akıllı telefon, tablet gibi) kaydedilen küçük metin dosyası veya
          bilgilerdir. Çerezler genellikle geldikleri internet site isimlerini, kullanım
          ömürlerini ve rastgele verilen sayılardan oluşan değerler içerir.
        </p>
      </div>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">Ne için Kullanıyoruz?</h2>
      <p>
        Kullanıcıların web sitesi, mobil uygulama ve/veya mobil site kullanımlarını
        kişiselleştirmek için kullanır. Bu kullanım:
      </p>
      <ol className="list-decimal space-y-2 ps-6">
        <li>
          Parolanızı kaydeden ve web sitesi/mobil uygulama/mobil sitesi oturumunuzun sürekli
          açık kalmasını sağlayan, böylece her ziyaretinizde birden fazla kez parola girme
          zahmetinden kurtaran çerezleri ve
        </li>
        <li>
          Web sitesi, mobil uygulama ve/veya mobil siteye daha sonraki ziyaretlerde kullanıcıyı
          hatırlayan ve tanıyan çerezleri içerir.
        </li>
      </ol>
      <p>
        Kullanıcıların web sitesine nereden ve hangi cihazlardan bağlandığı, sitede hangi içeriği
        görüntülediği ve ziyaret süresi gibi siteyi nasıl kullandığınızın tespiti de dahil olmak
        üzere, web sitesini kullanıcının nasıl kullandığını belirlemek amacıyla kullanır.
      </p>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">cagrinetwork.com.tr Çerezleri</h2>
      <p>
        İşbu gizlilik bildirisi sizleri gizliliğe ilişkin uygulamalarımız konusunda ve bize
        verdiğiniz kişisel bilgilerinizin nasıl kullanıldığı ve korunduğu hakkında bilgilendirmektedir.
        Bu politika (adresi www.cagrinetwork.com.tr olan) web sitesine ilişkindir. Web sitemizde üçüncü
        kişilere ait verilebilecek web sitesi linkleri bizim kontrolümüzde olmayıp işbu politika
        kapsamına dahil değildir. Sizden toplanan bilgiler başka bir üçüncü tarafa satılmayacak veya
        kiralanmayacaktır. ÇağrıNET size ait kişisel bilgileri iştirakları, üçüncü taraf acenteleri
        veya taşeronları ile paylaşma hakkını saklı tutar. Üçüncü taraf acenteleri ve taşeronlar size
        ait gizli mahiyetteki kişisel bilgileri gizlilik ilkesi çerçevesinde saklamayı taahhüt etmek
        zorunda olup bu bilgileri ÇağrıNET için gerçekleştirmekte oldukları hizmetler dışındaki
        amaçlar için kullanamazlar.
      </p>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">Hangi Türlerini Kullanıyoruz?</h2>
      <p>
        Oturum çerezleri (session cookies) ve kalıcı çerezler (persistent cookies) olmak üzere
        sitelerimiz genelinde iki tür çerez kullanmaktayız. Oturum çerezleri geçici çerezler olup
        sadece tarayıcınızı kapatıncaya kadar geçerlidirler. Kalıcı çerezler siz silinceye veya
        süreleri doluncaya kadar sabit diskinizde kalırlar.
      </p>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">Üçüncü Parti Çerezleri</h2>
      <p>
        İş ortaklarımız, reklam platformları, sosyal medya platformları ile analitik bilgileri
        toplama hizmeti veren, sitemiz genelinde kullanılan bu servis sağlayıcılar hizmetlerini
        sunabilmeleri için sitelerimizi ziyaret ettiğinizde, bizim yerimize cihazlarınıza çerez
        kaydetmelerine izin verebiliriz. cagrinetwork.com.tr ayrıca Google, Inc. tarafından sağlanan bir
        web analizi hizmeti olan Google Analytics kullanmaktadır.
      </p>

      <h2 className="font-display text-lg font-bold text-[#062B2B]">Çerezleri Nasıl Kontrol Edebilir veya Silebilirsiniz?</h2>
      <p>
        Birçok internet tarayıcısı, varsayılan olarak çerezleri otomatik olarak kabul etmeye
        ayarlıdır. Bu ayarları, çerezleri engelleyecek veya cihazınıza çerez gönderildiğinde uyarı
        verecek şekilde değiştirebilirsiniz. Çerezleri yönetmenin birkaç yolu bulunmaktadır.
      </p>
      <ul className="list-disc space-y-2 ps-6">
        <li><strong>Google Chrome:</strong> Tarayıcınızın adres bölümünde yer alan "kilit işareti" veya "i" harfini tıklayarak, "Cookie" sekmesinden çerezlere izin verebilir veya bloke edebilirsiniz.</li>
        <li><strong>İnternet Explorer:</strong> "Araçlar" bölümünden "Güvenlik" sekmesini tıklayın ve "izin ver" veya "izin verme" şeklinde çerez yönetiminizi gerçekleştirin.</li>
        <li><strong>Mozilla Firefox:</strong> "Seçenekler" görselini tıklayarak "Gizlilik ve Güvenlik" butonunu kullanarak çerez yönetiminizi yapınız.</li>
        <li><strong>Safari:</strong> Telefonunuzun "Ayarlar" bölümünden "Safari" sekmesini seçip, "Gizlilik ve Güvenlik" bölümünden tüm çerez yönetiminizi sağlayabilirsiniz.</li>
      </ul>
      <p>
        Eğer kullandığımız çerezleri devre dışı bırakırsanız, bu eylem cagrinetwork.com.tr sitesindeki
        kullanıcı deneyiminizi etkileyebilir.
      </p>
    </LegalPage>
  );
}
